import { legalClearanceLevelValidator } from './clearanceLevel';

export default legalClearanceLevelValidator;
